export default __webpack_public_path__ + "static/media/National Energy Board.867d7c39.jpg";